import { formatISO, parseISO, add } from 'date-fns';
import { UTCDate } from '@date-fns/utc';

export type Iso8601String = string;

export default class ISO8601 {
    /**
     * Gets the current local date/time in ISO 8601 format.
     * @returns The ISO 8601 string representation of the local date.
     */
    static now = () => formatISO(Date.now());

    /**
     * Gets the current UTC date/time in ISO 8601 format.
     * @returns The ISO 8601 string representation of the UTC date.
     */
    static nowUTC = () => formatISO(UTCDate.now());

    /**
     * Gets the current UTC date/time offset by a specified 
     * number of days in ISO8601 format.
     * @param delta The offet in days.
     * @returns The ISO 8601 string representation of the date.
     */
    static deltaUTC = (delta: number): string => {
        const offsetDate = add(new UTCDate, { days: delta })
        return formatISO(offsetDate);
    }

    static isValid = (str?: string) => {
        if (!str) return false;
        if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
        const d = new Date(str); 
        return !isNaN(d.getTime()) && d.toISOString()===str; // valid date 
    }
        
    static fromDate = (date: Date) => {
        return formatISO(date);
    }

    static toDate = (isoDate: string) => {
        return parseISO(isoDate);
    }
}

